import { useState } from "react";
import { HUMANLOOP_APP_SIGNUP } from "utils/constants";
import Button from "../library/Button";
import { LoadingIcon } from "../library/Icons";
import { classNames } from "../library/utils/classNames";

const BUTTON_TEXT = "Start for free";

export const CTASignup = ({ shade }: { shade?: "blue" | "black" }) => {
  const [loading, setLoading] = useState(false);
  return (
    <Button
      type="submit"
      styling="solid"
      shade={"blue"}
      className={classNames(
        "",
        loading ? "pl-32" : "px-32",
        "rounded-ms px-[40px]"
      )}
      loading={loading}
      IconRight={loading ? LoadingIcon : undefined}
      size={52}
      href={HUMANLOOP_APP_SIGNUP}
    >
      {BUTTON_TEXT}
    </Button>
  );
};
